<div class="container-fluid py-4">
  <!-- <h4 class="h4">(Courier Charges)</h4> -->

  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a class="btn btn-light btn-sm btn-reg"> Registry </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/qaRun']"
        >
          QA Run
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/internalLinks']"
        >
          Internal Links
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageDashboard']"
        >
          On-P Insights
        </a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing']"
        >
          Keywords
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageRecommendations']"
        >
          Off-P Recomm
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageProspects']"
        >
          Off-P Prospects
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageBacklinks']"
        >
          Off-P Backlinks
        </a>
      </div>
    </div>
  </div>

  <!-- Campo de búsqueda mejorado con autocompletado -->
  <!-- <br /><br /><br /> -->
  <div class="row mb-3 mt-1">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filter()"
          list="suggestionsCourier"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestionsCourier">
          <option
            *ngFor="let suggestion of searchSuggestions"
            [value]="suggestion"
          ></option>
        </datalist>
      </div>
    </div>
  </div>

  <a
    [routerLink]="['/marketing/seo/registry/add']"
    class="btn btn-dark btn-sm btn-new-sm"
  >
    <!-- <i class="fa-solid fa-circle-plus icon__plus"></i> -->
    NEW
  </a>
  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Url</th>
              <th>Type</th>
              <th>PublicationDate</th>
              <th>NextRefresh</th>
              <th>LastUpdate</th>
              <th>post_id_wp</th>
              <th>Owner</th>
              <th>Notes</th>
              <th>City</th>
              <th>Service</th>
              <th>Industry</th>
              <th class="th__status">Status</th>
              <th>Cannibalization</th>
              <th class="th__status">Published</th>
              <th class="th__status">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td
                class="url-cell"
                (click)="showModal('Full URL', item.urlPath)"
                title="Click to view full URL"
              >
                {{ item.urlPath }}
              </td>
              <td>{{ item.type }}</td>
              <td>{{ item.publicationDate | date: "yyyy-MM-dd" }}</td>
              <td>{{ item.nextRefresh | date: "yyyy-MM-dd" }}</td>
              <td>{{ item.lastUpdate | date: "yyyy-MM-dd" }}</td>
              <td>{{ item.postIdWp }}</td>
              <td class="city-cell">{{ item.owner }}</td>
              <td
                class="notes-cell"
                (click)="showModal('Notes', item.notes)"
                title="Click to view full notes"
              >
                {{ item.notes }}
              </td>
              <td class="city-cell">{{ item.city }}</td>
              <td>{{ item.service }}</td>
              <td>{{ item.industry }}</td>
              <td>
                <span
                  class="badge span__badge"
                  [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.status ? "Processed" : "Unprocessed" }}
                </span>
              </td>
              <td>
                <div *ngIf="item.cannibal">
                  <span
                    class="badge"
                    [ngClass]="{
                      'badge-danger': item.cannibal.severityMax === 'critical',
                      'badge-warning': item.cannibal.severityMax === 'high',
                      'badge-info': item.cannibal.severityMax === 'medium',
                      'badge-secondary': item.cannibal.severityMax === 'low',
                    }"
                  >
                    {{ item.cannibal.severityMax | uppercase }}
                  </span>
                  <br />
                  <small
                    class="text-muted"
                    *ngIf="item.cannibal.openClusterIds?.length"
                  >
                    Clusters: {{ item.cannibal.openClusterIds.length }}
                  </small>
                </div>
                <div *ngIf="item.seoGateStatus">
                  <span
                    class="badge"
                    [ngClass]="{
                      'badge-danger': item.seoGateStatus === 'blocked',
                      'badge-warning': item.seoGateStatus === 'monitor',
                      'badge-success': item.seoGateStatus === 'ok',
                    }"
                  >
                    GATE: {{ item.seoGateStatus | uppercase }}
                  </span>
                </div>
              </td>
              <td>
                <span
                  class="badge span__badge"
                  [ngClass]="item.published ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.published ? "Published" : "Not published" }}
                </span>
              </td>
              <td>
                <a
                  class="btn btn-link text-dark btn-sm btn-del"
                  routerLink="/marketing/seo/registry/edit/{{ item._id }}"
                  ><i class="fas fa-pen"></i
                ></a>
                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ modalContent }}
    </div>
  </div>
</div>
